<!-- 定金收取 -->
<template >
    <div class="new-contract-dialog">
        <el-dialog :visible.sync="visible" :title="$t('Charge.title1')" left >
            <div class="msph-dialog-title bg-gray mg-10">
                <p class="msph-dialog-title-p">
                    {{ $t('Common.name') }}：{{ client.clientName }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.phone') }}：{{ client.clientPhone }}
                </p>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="90px"
                label-suffix=":">
                <el-form-item :label="$t('Common.store')" prop="storeId" >
                    <el-select
                        v-model="form.storeId"
                        :placeholder="$t('Common.all_store2')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}-${item.name}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Reception.First.validity')" prop="validPeriod">
                    <el-input
                        v-model.trim.number="form.validPeriod"
                        type="number"
                        min="1"
                        :placeholder="$t('Fill.day')"
                        style="width: 168px;"></el-input>
                    <span> {{ $t('Week.day2') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Member.saler')" prop="contractSalesStaffId">
                    <el-select
                        v-model="form.contractSalesStaffId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full" clearable>
                        <input
                            class="search-input-all"
                            type="text"
                            v-model="searchText" >
                        <el-option
                            v-for="item in filterList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id == 'no'">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 身份证号：prop="certNum" -->
                <el-form-item
                    :label="$t('Sell.identity_number')"
                    class="fitness-redItem">
                    <el-input
                        type="text"
                        v-model="form.certNum"
                        :placeholder="$t('Fill.identity_number_placeholder')"/>
                </el-form-item>
                <el-form-item prop="remark" :label="$t('Common.remark')">
                    <el-input type="textarea" v-model="form.remark"/>
                </el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item :label="$t('Sell.Pay.title')" prop="payMethodCode">
                    <el-select
                        style="width: 185px;"
                        v-model.number="form.payMethodCode"
                        :placeholder="$t('Sell.Pay.title')">
                        <el-option :label="$t('Sell.Pay.cash')" :value="1"/>
                        <el-option :label="$t('Sell.Pay.swipe')" :value="2"/>
                        <el-option :label="$t('Sell.Pay.bank')" :value="3"/>
                        <el-option :label="$t('Sell.Pay.alipay')" :value="4"/>
                        <el-option :label="$t('Sell.Pay.wechat')" :value="5"/>
                        <el-option :label="$t('Sell.Pay.other')" :value="8"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Sell.Charge.ding')" prop="money">
                    <el-input v-model.trim.number="form.money" style="width:150px"/>
                    <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button
                    @click="submit"
                    type="primary"
                >{{ $t('Common.next_step') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
    Autocomplete,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';
import filterRole from '@/mixins/filterRole.js';
import timeMixin from '@/mixins/timeMixin.js';

export default {
    // contract - 合同名字，isDeposit - 是否定金合同
    // props: ['activeName'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        ElAutocomplete: Autocomplete,
        PayForm,
    },
    mixins: [filterRole, timeMixin],
    data() {
        return {
            visible: false,
            client: {
                clientName: 1,
                clientPhone: 12344,
            },
            form: {
                clientId: null,
                storeId: null,
                contractSalesStaffId: null,
                validPeriod: null,
                remark: null,
                payMethodCode: 1,
                money: null,
                certNum: null,
            },
            rules: {
                storeId: { required: true, message: this.$t('Common.store_placeholder') },
                validPeriod: { required: true, message: this.$t('Sell.Charge.vi_date') },
                contractSalesStaffId: { required: true, message: this.$t('Choose.saler') },
                payMethodCode: { required: true, message: this.$t('Sell.Pay.methods') },
                money: { required: true, message: this.$t('Sell.Charge.vi_money') },
                certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
            },
            stores: [],
            staffs: [],
            searchText: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        resetForm() {
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(client) {
            this.fetchClient(client.id);
            this.visible = true;
            this.resetForm();
            this.fetchStore();
            this.fetchSalers();
        },
        fetchClient(id) {
            API.get(`client/${id}/init-contract?type=5`)
                .then(res => {
                    this.client = res;
                    if (res.certNum) this.form.certNum = res.certNum;
                });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        async fetchSalers() {
            this.loading = true;
            // const ids = [5, 6];
            const ids = null;
            const {storeId} = this.form;
            this.staffs = await this.filterRole(null, ids, storeId, null, 'work');
            this.loading = false;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            form.clientId = this.client.clientId;
            API.post('contract/prepay', form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.pay_success'));
                    setTimeout(() => {
                        this.visible = false;
                        this.$router.push({
                            name: 'Sell.Index',
                            query: {
                                activeName: 'subscription',
                            },
                        });
                    }, 100);
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
    },
};
</script>

<style lang="scss">
.new-contract-dialog {
    .el-dialog {
        left: 50%;
        top: 50%;
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        width: 550px;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .msph-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .msph-dialog-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .box-1e {
        position: relative;
        left: 120px;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 75%;
        min-height: 150px;
    }
    .box-a {
        margin-left: 20px;
        padding: 10px 15px;
        background: #fff!important;
        min-height: 70px!important;
        overflow: scroll;
    }
    .contract_card_show {
        display: block;
        overflow: hidden;
        width: 160px;
        height: 100px;
        border-radius: 5px;
    }

}
</style>
